<p-dialog [style]="{ width: '42rem' }" [breakpoints]="{ '575px': '95vw' }"
    [(visible)]="visibility" [closable]="false" [modal]="true" [draggable]="false" [dismissableMask]="false">

  <ng-template #header>
    <div class="sn-header">
      <div class="sn-header-left">
        <i class="fa-solid fa-paper-plane sn-header-icon"></i>
        <span class="sn-header-title">Send notification</span>
      </div>
      <div class="sn-steps">
        <div class="sn-step" [class.active]="step() === 'audience' || step() === 'customers'" [class.done]="step() === 'compose' || step() === 'success'">
          <span class="sn-step-dot">@if (step() === 'compose' || step() === 'success') { <i class="fa-solid fa-check"></i> } @else { 1 }</span>
          <span class="sn-step-label">Audience</span>
        </div>
        <div class="sn-step-line" [class.done]="step() === 'compose' || step() === 'success'"></div>
        <div class="sn-step" [class.active]="step() === 'compose'" [class.done]="step() === 'success'">
          <span class="sn-step-dot">@if (step() === 'success') { <i class="fa-solid fa-check"></i> } @else { 2 }</span>
          <span class="sn-step-label">Compose</span>
        </div>
      </div>
      <button class="sn-close-btn" (click)="close()"><i class="fa-solid fa-xmark"></i></button>
    </div>
  </ng-template>

  <!-- ── STEP 1: Audience ── -->
  @if (step() === 'audience') {

    <!-- Audience type selector -->
    <p class="sn-section-label">Audience type</p>
    <div class="sn-audience-types">
      @for (type of audienceTypes; track type.value) {
      <button class="sn-type-card" [class.selected]="audienceType === type.value" (click)="onAudienceTypeChange(type.value)">
        <div class="sn-type-icon"><i [class]="type.icon"></i></div>
        <div class="sn-type-info">
          <span class="sn-type-label">{{ type.label }}</span>
          <span class="sn-type-desc">{{ type.desc }}</span>
        </div>
        <div class="sn-type-radio" [class.checked]="audienceType === type.value"></div>
      </button>
      }
    </div>

    <!-- CUSTOMER_GROUP target -->
    @if (audienceType === 'CUSTOMER_GROUP') {
      <p class="sn-section-label" style="margin-top:16px">Select customer group</p>
      <div class="sn-topic-list">
        @for (group of groups; track group.id) {
        <label class="sn-topic-item" [class.selected]="selectedGroupId === group.id">
          <input type="radio" name="group" [value]="group.id" [(ngModel)]="selectedGroupId" />
          <div class="sn-topic-dot" [style.background]="group.color"></div>
          <div class="sn-topic-info">
            <span class="sn-topic-name">{{ group.name }}</span>
            <span class="sn-topic-desc">{{ group.description }}</span>
          </div>
          <span class="sn-topic-subs">{{ group.memberCount }} members</span>
        </label>
        }
        @empty { <div class="sn-empty">No customer groups found.</div> }
      </div>
    }

    <!-- CUSTOMERS target -->
    @if (audienceType === 'CUSTOMERS') {
      <p class="sn-section-label" style="margin-top:16px">Select customers</p>
      <p-multiSelect
        class="sn-cust-multiselect"
        [options]="customerOptions"
        [(ngModel)]="selectedCustomerValues"
        optionLabel="label"
        optionValue="value"
        placeholder="Search and select customers..."
        [filter]="true"
        appendTo="body"
        (onPanelShow)="onCustPanelShow()"
        (onPanelHide)="onCustPanelHide()"
        (onFilter)="onCustFilter($event)">
        <ng-template #item let-opt>
          <div class="customer-option">
            <div class="customer-avatar">{{ opt.initials }}</div>
            <div class="customer-info">
              <span class="customer-name">{{ opt.label }}</span>
              <span class="customer-email">{{ opt.email }}</span>
            </div>
            <span class="customer-status" [style]="customerStatusStyle(opt.status)">{{ opt.status }}</span>
          </div>
        </ng-template>
      </p-multiSelect>
    }

    <!-- CUSTOMER_STATUS target -->
    @if (audienceType === 'CUSTOMER_STATUS') {
      <p class="sn-section-label" style="margin-top:16px">Select account statuses</p>
      <div class="sn-status-list">
        @for (s of availableStatuses; track s.value) {
        <span class="sn-status-item">
          <p-checkbox [binary]="true" [ngModel]="selectedStatuses.includes(s.value)"
            (ngModelChange)="toggleStatus(s.value)" />
          <span>{{ s.label }}</span>
        </span>
        }
      </div>
    }

    <!-- ALL_CUSTOMERS target -->
    @if (audienceType === 'ALL_CUSTOMERS') {
      <div class="sn-all-customers-info">
        <i class="fa-solid fa-globe"></i>
        <span>This notification will be sent to <strong>all customers</strong>.</span>
      </div>
    }

    <ng-template #footer>
      <div class="sn-footer">
        <p-button label="Cancel" variant="text" severity="secondary" size="small" (onClick)="close()" />
        <p-button label="Next" icon="fa-solid fa-arrow-right" iconPos="right" size="small" severity="primary"
          [disabled]="!canProceed" (onClick)="goToCompose()" />
      </div>
    </ng-template>
  }


  <!-- ── STEP 2: Compose ── -->
  @if (step() === 'compose') {
    <div class="sn-compose-summary">
      <i [class]="selectedAudienceType?.icon" style="color:var(--primary-color)"></i>
      <span>{{ audienceSummary }}</span>
      <button class="sn-edit-link" (click)="step.set('audience')">Edit</button>
    </div>

    <div class="sn-tab-bar" style="margin-bottom:12px">
      <button class="sn-tab" [class.active]="composeTab === 'template'" (click)="composeTab = 'template'">Use template</button>
      <button class="sn-tab" [class.active]="composeTab === 'custom'" (click)="composeTab = 'custom'">Custom notification</button>
    </div>

    @if (composeTab === 'template') {
      <div class="sn-template-list">
        @for (t of templates; track t.id) {
        <label class="sn-template-item" [class.selected]="selectedTemplateId === t.id">
          <input type="radio" name="template" [value]="t.id" [(ngModel)]="selectedTemplateId" />
          <div class="sn-template-info">
            <div class="sn-template-name-row">
              <span class="sn-template-name">{{ t.name }}</span>
              <span class="sn-tpl-cat" [class]="'cat-' + t.category.toLowerCase()">{{ categoryLabel(t.category) }}</span>
            </div>
            <span class="sn-template-title">{{ t.title }}</span>
            <span class="sn-template-body">{{ t.body }}</span>
          </div>
        </label>
        }
      </div>
      @if (selectedTemplate) {
      <div class="sn-preview">
        <span class="sn-preview-app">Yaldi · now</span>
        <p class="sn-preview-title">{{ selectedTemplate.title }}</p>
        <p class="sn-preview-body">{{ selectedTemplate.body }}</p>
      </div>
      }
    }

    @if (composeTab === 'custom') {
      <div class="sn-custom-form">
        <div class="sn-custom-field">
          <label for="sn-custom-title">Notification title</label>
          <input id="sn-custom-title" type="text" [(ngModel)]="customTitle" placeholder="Notification title" />
        </div>
        <div class="sn-custom-field">
          <label for="sn-custom-body">Message body</label>
          <textarea id="sn-custom-body" [(ngModel)]="customBody" placeholder="Write your message here..." rows="4" maxlength="160"></textarea>
          <span class="sn-char-count">{{ customBodyLength }} / 160 characters</span>
        </div>
      </div>
    }

    <ng-template #footer>
      <div class="sn-footer">
        <p-button label="Back" icon="fa-solid fa-arrow-left" size="small" variant="text" severity="secondary" (onClick)="step.set('audience')" />
        <p-button label="Send" icon="fa-solid fa-paper-plane" size="small" severity="primary" [loading]="sending()"
          [disabled]="composeTab === 'template' ? !selectedTemplateId : !customTitle || !customBody"
          (onClick)="send()" />
      </div>
    </ng-template>
  }

  <!-- ── STEP 3: Success ── -->
  @if (step() === 'success') {
    <div class="sn-success">
      <div class="sn-success-icon"><i class="fa-solid fa-check"></i></div>
      <h3 class="sn-success-title">Notification sent!</h3>
      <p class="sn-success-msg">{{ successTopicName }}</p>
    </div>
    <ng-template #footer>
      <div class="sn-footer sn-footer-center">
        <p-button label="Done" size="small" severity="primary" (onClick)="close()" />
      </div>
    </ng-template>
  }

</p-dialog>
